import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.keys.js";
import useInternalLink from '~/composables/useInternalLink';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default defineComponent({
  name: 'ItemMarketingBanner',
  components: {
    AzIcon: AzIcon
  },
  props: {
    banner: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(props) {
    var redirectLink = function redirectLink() {
      if (!isLinkCrawlableSeo.value && window && link.value) {
        window.location.href = link.value;
      }
    };
    var backgroundImage = computed(function () {
      var _props$banner, _props$banner$fields, _props$banner$fields$, _props$banner$fields$2, _props$banner$fields$3;
      return (_props$banner = props.banner) === null || _props$banner === void 0 ? void 0 : (_props$banner$fields = _props$banner.fields) === null || _props$banner$fields === void 0 ? void 0 : (_props$banner$fields$ = _props$banner$fields.backgroundImage) === null || _props$banner$fields$ === void 0 ? void 0 : (_props$banner$fields$2 = _props$banner$fields$.fields) === null || _props$banner$fields$2 === void 0 ? void 0 : (_props$banner$fields$3 = _props$banner$fields$2.file) === null || _props$banner$fields$3 === void 0 ? void 0 : _props$banner$fields$3.url;
    });

    /**
     * Property only existing on Ctnf item-marketing-block that is a wrapper of item-marketing-banner
     * If the property is not present, it means that the banner is not wrapped by a block so the link is crawlable
     **/
    var isLinkCrawlableSeo = computed(function () {
      var _props$banner2, _props$banner3;
      return (_props$banner2 = props.banner) !== null && _props$banner2 !== void 0 && _props$banner2.fields.hasOwnProperty('isLinkCrawlableSeo') ? (_props$banner3 = props.banner) === null || _props$banner3 === void 0 ? void 0 : _props$banner3.fields.isLinkCrawlableSeo : true;
    });
    var tagColor = computed(function () {
      var _props$banner4, _props$banner4$fields;
      return (_props$banner4 = props.banner) === null || _props$banner4 === void 0 ? void 0 : (_props$banner4$fields = _props$banner4.fields) === null || _props$banner4$fields === void 0 ? void 0 : _props$banner4$fields.tagColor;
    });
    var tagTitle = computed(function () {
      var _props$banner5, _props$banner5$fields;
      return (_props$banner5 = props.banner) === null || _props$banner5 === void 0 ? void 0 : (_props$banner5$fields = _props$banner5.fields) === null || _props$banner5$fields === void 0 ? void 0 : _props$banner5$fields.tagTitle;
    });
    var title = computed(function () {
      var _props$banner6, _props$banner6$fields;
      return (_props$banner6 = props.banner) === null || _props$banner6 === void 0 ? void 0 : (_props$banner6$fields = _props$banner6.fields) === null || _props$banner6$fields === void 0 ? void 0 : _props$banner6$fields.title;
    });
    var isBannerExists = computed(function () {
      var _props$banner7;
      return Object.keys((_props$banner7 = props.banner) === null || _props$banner7 === void 0 ? void 0 : _props$banner7.fields).length;
    });
    var description = computed(function () {
      var _props$banner8, _props$banner8$fields;
      return (_props$banner8 = props.banner) === null || _props$banner8 === void 0 ? void 0 : (_props$banner8$fields = _props$banner8.fields) === null || _props$banner8$fields === void 0 ? void 0 : _props$banner8$fields.description;
    });
    var contentType = computed(function () {
      var _props$banner9, _props$banner9$fields, _props$banner9$fields2, _props$banner9$fields3, _props$banner9$fields4, _props$banner9$fields5;
      return (_props$banner9 = props.banner) === null || _props$banner9 === void 0 ? void 0 : (_props$banner9$fields = _props$banner9.fields) === null || _props$banner9$fields === void 0 ? void 0 : (_props$banner9$fields2 = _props$banner9$fields.internalLink) === null || _props$banner9$fields2 === void 0 ? void 0 : (_props$banner9$fields3 = _props$banner9$fields2.sys) === null || _props$banner9$fields3 === void 0 ? void 0 : (_props$banner9$fields4 = _props$banner9$fields3.contentType) === null || _props$banner9$fields4 === void 0 ? void 0 : (_props$banner9$fields5 = _props$banner9$fields4.sys) === null || _props$banner9$fields5 === void 0 ? void 0 : _props$banner9$fields5.id;
    });
    var internalLinkObj = computed(function () {
      var _props$banner0, _props$banner0$fields;
      return (_props$banner0 = props.banner) === null || _props$banner0 === void 0 ? void 0 : (_props$banner0$fields = _props$banner0.fields) === null || _props$banner0$fields === void 0 ? void 0 : _props$banner0$fields.internalLink;
    });
    var _useInternalLink = useInternalLink({
        contentType: contentType,
        internalLinkObj: internalLinkObj
      }),
      internalLink = _useInternalLink.internalLink;
    var link = computed(function () {
      var _internalLinkObj$valu, _internalLinkObj$valu2, _props$banner1, _props$banner1$fields;
      return ((_internalLinkObj$valu = internalLinkObj.value) === null || _internalLinkObj$valu === void 0 ? void 0 : (_internalLinkObj$valu2 = _internalLinkObj$valu.fields) === null || _internalLinkObj$valu2 === void 0 ? void 0 : _internalLinkObj$valu2.publishedInProduction) && internalLink.value || ((_props$banner1 = props.banner) === null || _props$banner1 === void 0 ? void 0 : (_props$banner1$fields = _props$banner1.fields) === null || _props$banner1$fields === void 0 ? void 0 : _props$banner1$fields.externalLink) || '';
    });
    return {
      backgroundImage: backgroundImage,
      tagColor: tagColor,
      tagTitle: tagTitle,
      title: title,
      description: description,
      link: link,
      isLinkCrawlableSeo: isLinkCrawlableSeo,
      redirectLink: redirectLink,
      isBannerExists: isBannerExists
    };
  }
});